
import React from 'react';
import { Toaster } from 'sonner';

import { PostHogAnalytics } from './components/analytics/PostHogAnalytics';
import { AppProvider } from './contexts/AppContext';
import { AuthProvider } from './contexts/AuthContext';
import AppRouter from './router/AppRouter';

const App: React.FC = () => {
  return (
    <AppProvider>
      <AuthProvider>
        <PostHogAnalytics />
        <AppRouter />
        <Toaster
            richColors
            position="top-right"
            closeButton
            toastOptions={{
              classNames: {
                toast: 'bg-white shadow-xl border border-gray-100 rounded-2xl p-4 w-full md:w-[380px] font-sans items-start',
                title: 'text-gray-900 font-semibold text-sm leading-tight',
                description: 'text-gray-500 text-sm leading-relaxed mt-1.5',
                actionButton: 'bg-blue-600 !text-white font-medium text-xs px-3 py-2 rounded-lg transition-colors hover:bg-blue-700 h-auto self-center',
                cancelButton: 'bg-gray-100 !text-gray-600 font-medium text-xs px-3 py-2 rounded-lg transition-colors hover:bg-gray-200 h-auto self-center',
                closeButton: 'bg-transparent text-gray-400 hover:text-gray-600 hover:bg-gray-100 top-3 right-3',
              },
            }}
          />
      </AuthProvider>
    </AppProvider>
  );
};

export default App;
